module.exports = __webpack_public_path__ + "static/media/calendar-icon.4297987a.svg";